<template>
  <div class="custom-form-container">
    <el-form
      ref="formRef"
      :model="formData"
      :rules="formRules"
      :label-width="labelWidth"
      :label-position="labelPosition"
      class="custom-form"
    >
      <!-- 动态渲染表单项 -->
      <el-form-item
        style="margin-bottom: 20px"
        v-for="(item, index) in formItems"
        :key="index"
        :label="item.label"
        :prop="item.prop"
        :required="item.required || false"
        :class="{
          horizontal:
            item.type === 'radio' ||
            item.type === 'checkbox' ||
            item.type === 'switch',
        }"
      >
        <!-- 输入框 -->
        <el-input
          v-if="item.type === 'input'"
          v-model="formData[item.prop]"
          :placeholder="item.placeholder || `请输入${item.label}`"
          :disabled="item.disabled || false"
          :type="item.inputType || 'text'"
        ></el-input>

        <!-- 下拉框 -->
        <el-select
          v-else-if="item.type === 'select'"
          v-model="formData[item.prop]"
          :placeholder="item.placeholder || `请选择${item.label}`"
          :disabled="item.disabled || false"
          clearable
        >
          <el-option
            v-for="option in item.options"
            :key="option.value"
            :label="option.label"
            :value="option.value"
          ></el-option>
        </el-select>

        <!-- 单选框 -->
        <el-radio-group
          v-else-if="item.type === 'radio'"
          v-model="formData[item.prop]"
          :disabled="item.disabled || false"
        >
          <el-radio
            v-for="option in item.options"
            :key="option.value"
            :label="option.value"
          >
            {{ option.label }}
          </el-radio>
        </el-radio-group>

        <!-- 多选框 -->
        <el-checkbox-group
          v-else-if="item.type === 'checkbox'"
          v-model="formData[item.prop]"
          :disabled="item.disabled || false"
        >
          <el-checkbox
            v-for="option in item.options"
            :key="option.value"
            :label="option.value"
          >
            {{ option.label }}
          </el-checkbox>
        </el-checkbox-group>
        <!-- Switch 开关组件 -->
        <el-switch
          v-else-if="item.type === 'switch'"
          v-model="formData[item.prop]"
          :disabled="item.disabled || false"
          :active-text="item.activeText || ''"
          :inactive-text="item.inactiveText || ''"
          :active-value="
            item.activeValue !== undefined ? item.activeValue : true
          "
          :inactive-value="
            item.inactiveValue !== undefined ? item.inactiveValue : false
          "
          :active-color="item.activeColor || ''"
          :inactive-color="item.inactiveColor || ''"
          @change="(val) => handleSwitchChange(val, item.prop)"
        ></el-switch>

        <!-- 上传组件 -->
        <div v-else-if="item.type === 'upload'">
          <div class="upload-area">
            <UploadImg
              :file-list="uploadedFiles"
              :limit="3"
              accept="image/jpg,image/png,image/jpeg"
              :file-size="5"
              tip-text="支持JPG/PNG/JPEG格式，单文件不超过5M"
              @upload-success="handleUploadSuccess"
            />
            <!-- <el-upload
              class="upload-demo"
              drag
              action="#"
              :before-upload="beforeUpload"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                只能上传jpg/jpeg/gif/png文件，且不超过1MB
              </div>
            </el-upload> -->
          </div>
        </div>
        <!-- <el-upload
          v-else-if="item.type === 'upload'"
          :action="item.action"
          :headers="item.headers || {}"
          :file-list="formData[item.prop]"
          :on-success="(res, file) => handleUploadSuccess(res, file, item.prop)"
          :on-remove="(file) => handleUploadRemove(file, item.prop)"
          :limit="item.limit || 1"
          :accept="item.accept || '*'"
          :disabled="item.disabled || false"
          :auto-upload="item.autoUpload !== false"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            {{ item.tip || "请上传符合要求的文件" }}
          </div>
        </el-upload> -->
      </el-form-item>
      <slot></slot>
    </el-form>

    <!-- 操作按钮区域 -->
    <div class="form-button-group" :style="buttonGroupStyle">
      <CustomFormButton
        v-for="button in actionButtons.topArticleButtons"
        :isShowList="isShowList"
        :key="button.id"
        :text="button.text"
        :type="button.type"
        :size="button.size"
        :isPlain="button.isPlain"
        :icon="button.icon"
        :customStyle="button.customStyle"
        @click="handleClick(button)"
      />
    </div>
  </div>
</template>

<script>
import {
  articleTableHeaders,
  dialogTableHeaders,
  actionButtons,
} from "@/utils/defaultData";
export default {
  name: "CustomForm",
  props: {
    // 表单配置项（核心）
    formItems: {
      type: Array,
      required: true,
      default: () => [],
    },
    // 表单初始值
    initialFormData: {
      type: Object,
      default: () => {},
    },
    // 表单校验规则
    formRules: {
      type: Object,
      default: () => {},
    },

    // 表单标题和输入框布局排列
    labelPosition: {
      type: String,
      default: "left", // horizontal/vertical
    },
    // 标签宽度
    labelWidth: {
      type: String,
      default: "100px",
    },
    // 按钮配置
    showCancelBtn: {
      type: Boolean,
      default: true,
    },
    showConfirmBtn: {
      type: Boolean,
      default: true,
    },
    isShowList: {
      type: Array,
      default: () => [],
    },
    cancelBtnType: {
      type: String,
      default: "default", // primary/success/warning/danger/info/text
    },
    confirmBtnType: {
      type: String,
      default: "primary",
    },
    cancelBtnClass: {
      type: [String, Array, Object],
      default: "",
    },
    confirmBtnClass: {
      type: [String, Array, Object],
      default: "",
    },
    btnSize: {
      type: String,
      default: "medium", // large/medium/small/mini
    },
    buttonGroupStyle: {
      type: Object,
      default: () => ({
        marginTop: "20px",
        textAlign: "right",
      }),
    },
    // 按钮加载状态
    btnLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 表单数据
      formData: {},
      uploadedFiles: [], //已上传的文件列表
    };
  },
  created() {
    // 初始化表单数据
    this.initFormData();
  },
  methods: {
    // 初始化表单数据
    initFormData() {
      this.formData = { ...this.initialFormData };
      // 为未传入初始值的表单项设置默认值
      this.formItems.forEach((item) => {
        if (this.formData[item.prop] === undefined) {
          switch (item.type) {
            case "checkbox":
              this.formData[item.prop] = [];
              break;
            case "upload":
              this.formData[item.prop] = [];
              break;
            default:
              this.formData[item.prop] = "";
              break;
          }
        }
      });
    },
    // 按钮点击处理方法
    handleClick(button, row) {
      console.log("点击了按钮", button, row);
      // 可以在这里添加按钮点击逻辑
      if (button.handler) {
        this[button.handler](button, row);
      }
    },
    // Switch 开关变化回调
    handleSwitchChange(val, prop) {
      this.$emit("switch-change", { prop, value: val });
    },
    // 上传成功处理
    //   handleUploadSuccess(res, file, prop) {
    handleUploadSuccess(res, file, fileList) {
      console.log("CustomForm子组件上传成功回调函数", res, file, fileList);
      this.uploadedFiles = fileList.map((item) => ({
        url: item.response ? item.response.data : item.url,
        name: item.name,
      }));
      const uploadedFiles = this.uploadedFiles;
      //   this.formData[prop] = [file]; // 单文件上传，覆盖原有列表
      // 多文件可改为：this.formData[prop].push(file)
      this.$emit("upload-success", { res, file, uploadedFiles });
    },
    // 移除上传文件处理
    handleUploadRemove(file, prop) {
      this.formData[prop] = this.formData[prop].filter(
        (item) => item.uid !== file.uid,
      );
      this.$emit("upload-remove", { file, prop });
    },
    // 取消按钮回调
    handleCancelClick() {
      this.$emit("cancel");
      // 可选：取消后重置表单
      // this.resetForm();
    },
    // 确认按钮回调（带表单校验）
    async handleConfirmClick() {
      try {
        await this.$refs.formRef.validate();
        this.$emit("confirm", this.formData);
      } catch (error) {
        this.$emit("validate-fail", error);
        this.$message.error("表单校验失败，请检查填写内容");
      }
    },
    // 重置表单
    resetForm() {
      this.initFormData();
      this.$refs.formRef.resetFields();
      this.$emit("reset");
    },
    // 获取当前表单数据（供父组件调用）
    getFormData() {
      return this.formData;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-form {
  .el-form-item.horizontal {
    .el-form-item__label {
      float: left;
      margin-right: 30px;
    }
    .el-form-item__content {
    }
  }
}
::v-deep.el-form.el-form--label-top {
  .el-form-item {
    margin-bottom: 5px !important;
  }
}
// ::v-deep .horizontal {
//   .el-form-item {
//     border: 2px solid red;
//     display: flex;
//     flex-direction: column;
//     .el-form-item__label {
//       text-align: left;
//     }
//     .el-form-item__content {
//       margin-left: 0px !important;
//     }
//   }
// }
// ::v-deep .vertical {
//   .el-form-item {
//     display: flex;
//     .el-form-item__label {
//     //   text-align: center;
//     }
//     .el-form-item__content {
//       margin-left: 10px !important;
//     }
//   }
// }
.custom-form-container {
  .el-form-item {
    // margin-bottom: 15px !important;
    // width: 90% !important;
  }
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
}

.custom-form {
  width: 100%;
}

.form-button-group {
  margin-top: 20px;
}

.form-button-group button {
  margin-left: 8px;
}
</style>
